import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { obterDashboardCgcCpf } from '~/Services/Service';
import FilterSection from './components/FilterSection';
import DashboardSection from './components/DashboardSection';
import AccordionDrillDowns from './components/AccordionDrillDowns';

const ConsultaCgcCpf = () => {
  const [dashboard, setDashboard] = useState(null);
  const [filtroAtivo, setFiltroAtivo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [abrirCedentes, setAbrirCedentes] = useState(false);

  const handleConsultar = (valores) => {
    setAbrirCedentes(false);
    setFiltroAtivo(null);
    setDashboard(null);
    setLoading(true);

    obterDashboardCgcCpf({
      cgc_cpf: valores.cgc_cpf,
      codigo_grupo_empresa: valores.codigo_grupo_empresa,
    })
      .then((res) => {
        setDashboard(res);
        setFiltroAtivo(valores);
      })
      .catch((err) => {
        const msg =
          err && err.message ? err.message : 'Erro ao realizar consulta.';
        toast.error(msg);
      })
      .finally(() => setLoading(false));
  };

  const handleLimpar = () => {
    setDashboard(null);
    setFiltroAtivo(null);
    setAbrirCedentes(false);
  };

  return (
    <div className="container-fluid mt-3">
      <h4 className="mb-3">Consulta CGC/CPF</h4>

      <FilterSection
        onConsultar={handleConsultar}
        onLimpar={handleLimpar}
        loading={loading}
      />

      {loading && (
        <div className="text-center py-4">
          <span className="text-muted">Consultando...</span>
        </div>
      )}

      {!loading && dashboard && (
        <>
          <DashboardSection
            data={dashboard}
            onAbrirCedentes={() => setAbrirCedentes(true)}
          />

          <AccordionDrillDowns
            filtro={filtroAtivo}
            dashboard={dashboard}
            abrirCedentesKey={abrirCedentes}
          />
        </>
      )}
    </div>
  );
};

export default ConsultaCgcCpf;
